import { render, staticRenderFns } from "./DropdownMenuHeader.vue?vue&type=template&id=40275837&"
import script from "./DropdownMenuHeader.vue?vue&type=script&lang=ts&"
export * from "./DropdownMenuHeader.vue?vue&type=script&lang=ts&"
import style0 from "./DropdownMenuHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports